import { Box, Card, CardContent, Grid } from "@material-ui/core";
import ButtonWithLoading from "../../../../../components/ButtonWithLoading";
import { DatePicker } from "../../../../../components/DatePicker";
import DialogComponent from "../../../../../components/Dialog";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useParams } from "react-router";
import { getTranslation } from "../../../../../heplers/translationHelper";
import moment from "moment";
import dayjs from "dayjs";

export const EndContractDialog = ({ isOpen, endContractId, date, type, onClose, onSubmit }) => {
  
  
  const initialValues = {
    id: endContractId,
    date: date && date.includes("0001") ? dayjs().format("YYYY-MM-DD") : (date ? date.slice(0, 10) : dayjs().format("YYYY-MM-DD")),
    type:type
  };

  const basicValidationSchema = Yup.object().shape({
    date: Yup.date().required("End Date is required"),
  });

  const defaultValue = initialValues;
  return (
    <DialogComponent
      fullWidth
      title={type=="start"? getTranslation("Modify Start Date","Modify Start Date","Modify Start Date") : getTranslation("Modify End Date","Modify End Date","Modify End Date")}
      open={isOpen}
      onClose={onClose}
    >
      <Card>
        <CardContent>
          <Formik
            enableReinitialize
            initialValues={defaultValue}
            validationSchema={basicValidationSchema}
            onSubmit={(values, actions) => {
              actions.setSubmitting(true);
              onSubmit(values, actions);
            }}
          >
            {({
              errors,
              touched,
              values,
              handleSubmit,
              isSubmitting,
              getFieldProps,
              setFieldValue,
            }) => (
              <Form>
                <Grid container>
                  <Grid xs={12} sm={12} md={6} lg={6}>
                    <DatePicker
                      label="Date"
                      value={values.date}
                      required
                      onChange={(newDate) => {
                        console.log("jkahdkjashkjahdad",newDate.toString())
                        setFieldValue("date", newDate.toString());
                      }}
                      error={touched.date && Boolean(errors.date)}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "flex-end",
                    }}
                  >
                    <ButtonWithLoading
                      title={getTranslation("Change","Change","Change")}
                      color="primary"
                      variant="contained"
                      size="small"
                      loading={isSubmitting}
                      onClick={handleSubmit}
                    />
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </DialogComponent>
  );
};
